import { SystemText } from 'e4shared';
import React from 'react';
import { useSelector } from 'react-redux';

export const Rating = ({ level, hideOutOf }) => {
    const ratingsRange = useSelector(state => state.user.user.companySettings?.display?.ratingRange || 5);
    const noScore = SystemText('General/NoScore');

    return (
        <span className={`label label-rating label-rating-${level}`}>
            {level > 0 ? (
                <>
                    {level} {!hideOutOf && <>/ {ratingsRange}</>}
                </>
            ) : (
                <>{noScore}</>
            )}
        </span>
    );
};

export default Rating;
